import i18next from '../i18next';
// import logoVaEn from '../asset/svg/logo_va.ts';
import { defaultConfig, getBucketRegionByRegion } from './config.default';

const unifyTenantConfig = /*#__PURE__*/ (() => ({
  get brand_name() {
    return i18next.t('Meego_Shared_Web_Common_LarkProject');
  },
  get feishu_brand_name() {
    return i18next.t('Meego_Shared_Web_Common_Lark');
  },
  get web_title() {
    return i18next.t('Meego_Shared_Web_Common_LarkProject');
  },
  get workbench_title() {
    return i18next.t('Meego_Shared_Web_Common_LarkProject');
  },
  get brand_desc() {
    return i18next.t('Meego_Shared_Web_Common_MakeProjectManagementEasier');
  },
  get logo_url_promise() {
    return import('../asset/svg/logo_va.ts');
  },
  get bot_name() {
    return i18next.t('Meego_Shared_Lark_Common_BotName');
  },
}))();

const region = /*#__PURE__*/ (() => window.region || 'va')();

const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,

  region: region,
  avatarDomain: 'https://meegle.com/goapi',
  host: 'https://meegle.com',
  hostForGo: 'https://meegle.com/goapi',
  collectHost: 'https://miigo-monitor.bytedance.com/inner',

  guideLink: 'https://bytedance.feishu.cn/docs/doccnhGBz5VDr5xFsGV9bGgcpwe',
  currentHost: 'https://meegle.com',
  tosBucket: 'meego-business-' + getBucketRegionByRegion(region),
  larkLoginHost: 'https://www.larksuite.com',
  tenantConfig: unifyTenantConfig,
  TeaConfig: {
    ...defaultConfig.TeaConfig,
    channel: region === 'sg' ? 'sg' : 'va',
    app_id: 441507,
  },
  slardarConfig:
    region === 'sg'
      ? {
          domain: 'slardar-bd-sg.larksuite.com',
        }
      : {},
  labProjectId: '620b229097e53d8b28d33e98',
  labViewId: 'bpcVAgB7RZ',
  showTenantIds: [],
  helpcenterUrl: 'https://meegle.com/helpcenter/home',
  internalApi: 'meegle.com',
  passportApi: 'passport.larksuite.com',
}))();

export default config;
